export default (state = {}, action) => {
    switch(action.type){
        case 'FETCH_METADATA_CHART':
            return action.payload;
        default: return state;
    }
}